<template>
    <div class="table-sidebar" :class="{'open': open}">
        <div class="toggle-sidebar" @click="open = !open">
            <i v-if="!open" class="mdi mdi-cog"></i>
            <i v-else class="mdi mdi-close"></i>
        </div>
        <div class="table-sidebar-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                open: false
            }
        }
    }
</script>